import React from 'react';
import { Alert, AlertDescription } from '../ui/alert';

/**
 * OfficeHoursHint - Displays suggestion for office hours scheduling
 * Non-enforced, just a helpful reminder
 */
const OfficeHoursHint = ({ suggestedTime, onUseSuggestion }) => {
  const formatTime = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Alert className="bg-blue-50 border-blue-200 mb-4">
      <AlertDescription className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-blue-900">
          <span>💡</span>
          <span>
            <strong>Suggested:</strong> Office hours (9 AM–9 PM) for better engagement.
            {suggestedTime && ` Try ${formatTime(suggestedTime)}`}
          </span>
        </div>
        {onUseSuggestion && suggestedTime && (
          <button
            onClick={onUseSuggestion}
            className="text-xs bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
          >
            Use Suggestion
          </button>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default OfficeHoursHint;
